import React from 'react'
import { IconToggle } from 'react-mdl'

export const hasMark = state =>
  state.marks.some(mark => mark.type === 'underline')

export const markStrategy = state =>
  state.transform().toggleMark('underline').focus().apply()

const Node = ({ children }) => (
  <u>
    {children}
  </u>
)

const Schema = {
  marks: {
    underline: Node,
  },
}

const KeyboardShortcut = (event, data, state) => {
  if (data.isMod && data.key === 'u') return markStrategy(state)
  return
}

const Button = ({ state, onChange }) => (
  <IconToggle
    name="format_underline"
    onChange={() => onChange(markStrategy(state))}
    checked={hasMark(state)}
  />
)

const Plugin = () => ({
  schema: Schema,

  onKeyDown(...args) {
    return KeyboardShortcut(...args)
  },
})

export { Button as UnderlineButton, Plugin as UnderlinePlugin }



// WEBPACK FOOTER //
// ./src/components/Editor/plugins/Underline.js